<template>
  <v-layout align-start>
    <v-flex>
      <v-app-bar>
        <v-toolbar-title class="font-weight-black primary--text"
          >Usuarios</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nuevo registro</span>
        </v-tooltip>
      </v-app-bar>
      <v-data-table
        dense
        :headers="headers"
        :items="usuarios"
        :search="search"
        sort-by="calories"
        class="elevation-1"
        :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página',
          'items-per-page-options': [50, 100, 150, -1],
        }"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-btn x-small text dark color="primary" @click="editItem(item)">
            <v-icon x-small>edit</v-icon>
          </v-btn>
          <v-btn
            x-small
            text
            dark
            color="primary"
            @click="mostrarSubareas(item)"
          >
            <v-icon x-small>6_ft_apart</v-icon>
          </v-btn>
          <v-btn
            x-small
            text
            dark
            color="secondary"
            @click="mostrarRoles(item)"
          >
            <v-icon x-small>group</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.roles_count`]="{ item }">
          <v-chip
            :color="item.roles_count > 0 ? 'success' : 'grey'"
            :text-color="item.roles_count > 0 ? 'white' : 'black'"
            small
            @click="mostrarRoles(item)"
            class="cursor-pointer"
          >
            {{ item.roles_count || 0 }}
          </v-chip>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado == 'A'">
            <v-btn color="success" x-small text dark @click="desactivar(item)">
              <v-icon x-small>check</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" x-small text dark @click="activar(item)">
              <v-icon x-small>block</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card ref="form">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="usuario"
                          v-model="usuario"
                          :rules="[rules.requerido, rules.min2, rules.max50]"
                          :error-messages="errorMessages"
                          label="Usuario"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                          outlined
                          dense
                          ref="id_rol"
                          v-model="id_rol"
                          :items="roles"
                          :rules="[rules.requerido]"
                          :error-messages="errorMessages"
                          label="Rol"
                          item-text="descripcion"
                          item-value="id"
                          required
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">Cancelar</v-btn>
                  <v-btn color="primary" text @click="guardar">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogSubarea" persistent max-width="500px">
              <v-card ref="form">
                <v-card-title> </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-flex>
                        <v-data-table
                          dense
                          :headers="headersSubarea"
                          :items="Subareas"
                          :search="searchSubarea"
                          :page.sync="page"
                          :items-per-page="itemsPerPage"
                          sort-by="descripcion"
                          class="elevation-1"
                          :header-props="{
                            'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                          }"
                          :footer-props="{
                            showFirstLastPage: true,
                            'items-per-page-text': 'Filas por página',
                            'items-per-page-options': [50, 100, 150, -1],
                          }"
                        >
                          <template v-slot:[`item.estado`]="{ item }">
                            <div v-if="item.estado == 'A'">
                              <v-btn
                                color="success"
                                x-small
                                text
                                dark
                                @click="deleteItemSubarea(item)"
                              >
                                <v-icon x-small>check</v-icon>
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                color="error"
                                x-small
                                text
                                dark
                                @click="asignar(item)"
                              >
                                <v-icon x-small>block</v-icon>
                              </v-btn>
                            </div>
                          </template>

                          <template v-slot:no-data>
                            <v-btn color="primary" @click="listarUsuarioSubarea"
                              >Reset</v-btn
                            >
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeSubarea"
                    >Volver</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Dialog para asignación de roles -->
            <DialogRolesUsuarioNuevo
              v-model="dialogRoles"
              :id-usuario="usuarioSeleccionado.id"
              :usuario="usuarioSeleccionado.nombre"
              @rol-cambiado="actualizarContadorRoles"
            />

            <v-dialog v-model="dialogBorrarSubarea" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción borrará la asignación de Subarea al
                  Usuario.</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogBorrarSubarea = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="primary" text @click="remover()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import DialogRolesUsuarioNuevo from "./Generico/DialogRolesUsuarioNuevo.vue";

export default {
  components: {
    DialogRolesUsuarioNuevo,
  },
  data() {
    return {
      usuarios: [],
      roles: [],
      tipoDocumento: [
        "Carnet Identidad",
        "Pasaporte",
        "Run",
        "CI de Extranjero",
        "Otro",
      ],
      dialog: false,
      dialogSubarea: false,
      dialogSubareaEdit: false,
      dialogBorrarSubarea: false,
      dialogRoles: false,

      page: 1,
      itemsPerPage: -1,
      headers: [
        {
          text: "Usuario",
          value: "usuario",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Último Acceso",
          value: "ultimo_ingreso",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Roles",
          value: "roles_count",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Activo",
          value: "estado",
          sortable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersSubarea: [
        {
          text: "Área",
          value: "codigo_area",
        },
        {
          text: "Subarea",
          value: "codigo_subarea",
        },
        {
          text: "Descripción",
          value: "descripcion_subarea",
        },
        {
          text: "Asignado",
          value: "estado",
          sortable: false,
          width: "10%",
          align: "center",
        },
      ],

      options: [
        {
          page: 1,
          itemsPerPage: 2,
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchSubarea: "",
      desserts: [],
      editedIndex: -1,
      SubareasList: [],
      Subareas: [],
      user: this.$store.state.usuario.user,
      id: "",
      id_subarea: "",
      usuario: "",
      usuarioAplicacion: this.$store.state.usuario.user,
      nombre: "",

      id_rol: "",

      codigo: "",
      descripcion: "",
      generos: "",
      genero: "",

      valida: 0,

      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
      usuarioSeleccionado: {
        id: null,
        nombre: '',
        usuario: ''
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Actualizar Usuario";
    },

    form() {
      return {
        usuario: this.usuario,

        id_rol: this.id_rol,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
    },
  },

  created() {
    this.listar();
    this.selectRoles();
  },

  methods: {
    listar() {
      let me = this;
      axios
        .get("api/usuarios/listar")
        .then(function (response) {
          // Inicializar usuarios y cargar conteo de roles
          me.usuarios = response.data.map(usuario => ({
            ...usuario,
            roles_count: usuario.roles_count || 0
          }));
          // Cargar el conteo real de roles para cada usuario
          me.cargarConteoRoles();
        })
        .catch(function (error) {
          console.log(error);
          me.$store.dispatch("setSnackbar", {
            text: "Error al cargar usuarios",
            color: "error",
          });
        });
    },

    async cargarConteoRoles() {
      // Cargar el conteo de roles para cada usuario
      for (let usuario of this.usuarios) {
        try {
          const response = await axios.get(`api/Usuarios/ListarRoles/${usuario.id}`);
          if (response.data && Array.isArray(response.data)) {
            // Contar solo los roles asignados (estado === 'Asignado')
            const rolesAsignados = response.data.filter(rol => rol.estado === 'Asignado').length;
            this.$set(usuario, 'roles_count', rolesAsignados);
          }
        } catch (error) {
          console.log(`Error al cargar roles para usuario ${usuario.id}:`, error);
          // Mantener el valor por defecto de 0 en caso de error
        }
      }
    },
    listarUsuarioSubarea() {
      let me = this;
      axios
        .get("api/usuario_subareas/listarTodasSubareaUsuario/" + this.id)
        .then(function (response) {
          me.Subareas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectRoles() {
      let me = this;
      var estadoArray = [];
      axios
        .get("api/roles/select")
        .then(function (response) {
          me.roles = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addItem() {
      this.dialog = true;
    },

    editItem(item) {
      this.id = item.id;

      this.usuario = item.usuario;
      this.id_rol = item.id_rol;

      this.editedIndex = 1;
      this.dialog = true;
    },
    mostrarSubareas(item) {
      this.id = item.id;

      this.dialogSubarea = true;
      this.listarUsuarioSubarea();
    },

    mostrarRoles(item) {
      this.usuarioSeleccionado = {
        id: item.id,
        nombre: item.nombre || item.usuario,
        usuario: item.usuario
      };
      this.dialogRoles = true;
    },

    actualizarContadorRoles(data) {
      // Buscar el usuario en la lista y actualizar su contador de roles
      const usuario = this.usuarios.find(u => u.id === data.idUsuario);
      if (usuario) {
        this.$set(usuario, 'roles_count', data.rolesAsignados);
      }
      
      // Si el usuario modificado es el usuario actual logueado, actualizar roles en el store
      if (this.$store.state.usuario && 
          this.$store.state.usuario.idUsuario && 
          parseInt(this.$store.state.usuario.idUsuario) === data.idUsuario) {
        console.log('Actualizando roles del usuario actual en el store...');
        this.$store.dispatch('actualizarRolesUsuario');
      }
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    deleteItemSubarea(item) {
      this.id_subarea = item.id_subarea;
      this.dialogBorrarSubarea = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    closeSubarea() {
      this.dialogSubarea = false;
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.usuario = "";

      this.id_rol = "";

      this.validaMensaje = [];
      this.editedIndex = -1;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put("api/usuarios/actualizar", {
            id: me.id,
            usuario: me.usuario,
            user: me.user,
            id_rol: me.id_rol,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: "Usuario modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/usuarios/crear", {
            usuario: me.usuario,
            user: me.user,
            id_rol: me.id_rol,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: "Usuario creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/usuarios/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Usuario activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/usuarios/desactivar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Usuario desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    remover() {
      let me = this;

      axios
        .put(
          "api/usuario_subareas/EliminarUsuarioSubarea/" +
            me.id +
            "/" +
            me.id_subarea +
            "/" +
            me.usuarioAplicacion,
          {}
        )
        .then(function (response) {
          me.listarUsuarioSubarea();
          me.$store.dispatch("setSnackbar", {
            text: "Subarea removida exitosamente.",
            color: "success",
          });
          me.dialogBorrarSubarea = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    asignar(item) {
      console.log("Primer paso");
      let me = this;
      axios
        .post("api/Usuario_subareas/crear", {
          id_usuario: me.id,
          id_subarea: item.id_subarea,
          usuario: me.usuarioAplicacion,
        })
        .then(function (response) {
          me.listarUsuarioSubarea();

          me.$store.dispatch("setSnackbar", {
            text: "Registro creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
